import account from './account/account';
import activeGames from './activeGames/activeGames';
import cms from './cms/cms';
import config from './config/config';
import country from './country/country';
import currency from './currency/currency';
import device from './device/device';
import feature from './feature/feature';
import localSettings from './localSettings/localSettings';
import locale from './locale/locale';
import location from './location/location';
import modal from './modal/modal';
import resolver from './resolver/resolver';
import rewards from './rewards/rewards';
import session from './session/session';
import system from './system/system';
import timeZone from './timeZone/timeZone';

export type { ConfigState } from './config/config';
export { keys } from './config/config';
export type { Feature, FeatureState } from './feature/feature';
export { Size } from './modal/modal';
export type { Modal, ModalState } from './modal/modal';
export { resolverTokenType } from './resolver/resolver';
export type { ResolvedTag, ResolverState, FetchTagPayload } from './resolver/resolver';

export { LoginSource } from './session/session';
export type { SessionState, AuthenticatedSession, SessionResponse } from './session/session';

export type { AccountState } from './account/account';
export type { CasinoGameHistoryPayload, HandHistoryPayload } from './account/effects';
export { getRequestPayload, requestOverride, defaultLayout } from './cms/effects';
export type { CountryState } from './country/country';
export type { DeviceState } from './device/device';
export type { LocaleState } from './locale/locale';
export type { LocationState } from './location/location';
export type { LocalSettingsState } from './localSettings/localSettings';
export type { SystemState } from './system/system';
export type { RewardsState } from './rewards/rewards';
export type { Alias, BasicContentItem, CMSState, Page } from './cms/cms';

// TODO remove export after rewards model is fully ported back in SW
export { defaultState as rewardsDefaultState } from './rewards/rewards';
export { defaultState as cmsDefaultState } from './cms/cms';

export { makeLocationState } from './location/location';

// eslint-disable-next-line
export type Models = {
  account: typeof account;
  activeGames: typeof activeGames;
  device: typeof device;
  resolver: typeof resolver;
  session: typeof session;
  currency: typeof currency;
  config: typeof config;
  country: typeof country;
  modal: typeof modal;
  feature: typeof feature;
  system: typeof system;
  location: typeof location;
  locale: typeof locale;
  cms: typeof cms;
  localSettings: typeof localSettings;
  rewards: typeof rewards;
  timeZone: typeof timeZone;
};

const models: Models = {
  account,
  activeGames,
  device,
  resolver,
  session,
  currency,
  config,
  country,
  modal,
  feature,
  system,
  location,
  locale,
  cms,
  localSettings,
  rewards,
  timeZone
};

export default models;
